import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import SidebarGuest from './SidebarGuest';

export default function GuestDashboardLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const [current, setCurrent] = useState('home');
  const [showVisitorInfo, setShowVisitorInfo] = useState(false);

  // Update current state based on route changes
  useEffect(() => {
    const path = location.pathname;
    if (path === '/guest/home') {
      setCurrent('home');
    } else if (path === '/guest/map') {
      setCurrent('map');
    } else if (path.startsWith('/guest/public-access/')) {
      setCurrent('public');
    }
  }, [location.pathname]);

  // Pills
  const isVisitorInfoRoute = location.pathname === '/guest/public-access/visitor-info';
  const showVisitorInfoPill = current === 'public' && !showVisitorInfo && !isVisitorInfoRoute;

  // Main sidebar nav logic
  const handleNavigate = (target, data) => {
    console.clear(); // Clear the console to see navigation logs clearly
    console.log('=== GUEST NAVIGATION DEBUG ===');
    console.log('handleNavigate called with:', target, 'from:', location.pathname);
    setShowVisitorInfo(false);
    
    // Force a page reload when navigating away from the map to ensure clean navigation
    const isCurrentlyOnMap = location.pathname === '/guest/map';
    
    if (target === 'home') {
      setCurrent('home');
      if (isCurrentlyOnMap) {
        console.log('Using page reload for map navigation');
        window.location.href = '/guest/home';
      } else {
        navigate('/guest/home');
      }
    } else if (target === 'map') {
      setCurrent('map');
      if (data && data.lotId) {
        navigate('/guest/map', { state: { selectedLotId: data.lotId } });
      } else {
        navigate('/guest/map');
      }
    } else if (target === 'plot-availability') {
      setCurrent('public');
      if (isCurrentlyOnMap) {
        console.log('Using page reload for map navigation');
        window.location.href = '/guest/plot-availability';
      } else {
        navigate('/guest/plot-availability');
      }
    } else if (target === 'public') {
      setCurrent(prev => prev === 'public' ? null : 'public');
    }
  };

  // Visitor info
  const handleVisitorInfo = () => {
    console.log('Guest visitor info clicked from:', location.pathname);
    setShowVisitorInfo(true);
    setCurrent('public');
    
    // Use page reload fallback when navigating from map
    const isCurrentlyOnMap = location.pathname === '/guest/map';
    if (isCurrentlyOnMap) {
      console.log('Using page reload for visitor info navigation from map');
      window.location.href = '/guest/public-access/visitor-info';
    } else {
      navigate('/guest/public-access/visitor-info');
    }
  };

  // Login redirect
  const handleLogin = () => {
    console.log('Guest login clicked from:', location.pathname);
    
    // Use page reload fallback when navigating from map (similar to other navigation)
    const isCurrentlyOnMap = location.pathname === '/guest/map';
    if (isCurrentlyOnMap) {
      console.log('Using page reload for login navigation from map');
      window.location.href = '/login';
    } else {
      console.log('Using normal navigation to login');
      navigate('/login');
    }
  };

  return (
    <div style={{ display: 'flex' }}>
      <SidebarGuest
        onNavigate={handleNavigate}
        onLogin={handleLogin}
        current={current}
        showVisitorInfoPill={showVisitorInfoPill}
        onVisitorInfo={handleVisitorInfo}
      />
      <main style={{ flex: 1, padding: '1rem', paddingTop: '80px', paddingBottom: '0rem' }}>
        <Outlet context={{ handleNavigate, handleVisitorInfo }} />
      </main>
    </div>
  );
} 